import styled from "styled-components";
export const PageElementContainer = styled.div `
    display: flex;
    height: 100vh;
    width: 100vw;
    justify-content: space-around;
    align-items: center;
    position: relative;
`;
